/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import Stack from './Stack';
import useLegends from './useLegends';
import { css, jsx } from '@emotion/core';
import { useState } from 'react';

const Button = (props) => (
  <a
    onClick={props.onClick}
    css={css(`
          height: 30px;
          padding: 5px;
          cursor: pointer;
          z-index: 999;
          pointer: click;
          float: right;
        `)}
  >
    {props.children}
  </a>
);

const Component = (): null | Element<string> => {
  const shouldStartOpen = true;
  const [isOpen, setOpen] = useState(shouldStartOpen);
  const legends = useLegends();
  if (legends.filter((v) => v.type).isEmpty()) return null;

  return (
    <div
      css={css(`
        background: white;
        padding: 0;
        border: solid 1px #ccc;
        border-radius: 3px;
        overflow: auto;
        max-height: 400px;
      `)}
    >
      <Button onClick={() => setOpen((v) => !v)}>
        {isOpen ? (
          <span className="fa fa-window-minimize" />
        ) : (
          <span>Legend</span>
        )}
      </Button>
      <Stack open={isOpen} />
    </div>
  );
};

export default Component;
